import { Small } from "@/shared/ui/Button/Button";
import { clsx } from "clsx";
import { Title } from "@/shared/ui/Title";
import { useDevice } from "@/shared/lib/hooks/useDevice";
import { useUser } from "@/entities/Auth";
import { UserRole } from "@/shared/const/userRole";
import { getRouteHome, getRouteManageReadings } from "@/shared/const/routes";

import cls from "./NotFound.module.scss";

export const NotFound = () => {
  const { isMobile } = useDevice();
  const user = useUser();

  const clickHome = () => {
    window.location.href = user.role === UserRole.Writer ? getRouteManageReadings() : getRouteHome();
  };

  const clickRefresh = () => {
    window.location.reload();
  };

  return (
    <div className={clsx(cls.NotFound, { [cls.isMobile]: isMobile })}>
      <Title>Not Found</Title>
      <div className={cls.Text}>
        <p>Oops, page you are looking for is not found. You can try next actions below.</p>
      </div>
      <div className={cls.Buttons}>
        <Small onClick={clickHome}>Go Home</Small>
        <span>or</span>
        <Small onClick={clickRefresh}>Try Again</Small>
      </div>
    </div>
  );
};
